import { render, staticRenderFns } from "./SubQuestionSection.vue?vue&type=template&id=58b61134&scoped=true&"
import script from "./SubQuestionSection.vue?vue&type=script&lang=ts&"
export * from "./SubQuestionSection.vue?vue&type=script&lang=ts&"
import style0 from "./SubQuestionSection.vue?vue&type=style&index=0&id=58b61134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b61134",
  null
  
)

export default component.exports